import { TagsOptions } from 'src/types/Main'
import { clearColorHexa, isMulticolor } from 'src/components/utils/clearColorHexa'
import clearColorTitle from 'src/components/utils/clearColorTitle'
import { translateString } from '../../utils/translateString'

interface Props {
  tagType: string;
  values: string[];
  tagsOptions: Record<string, TagsOptions[]>;
  removeTag: (tagToRemove: string, tagType: string) => void;
}

const FilteredColorTag = (props: Props) => {
  const { tagType, values, tagsOptions, removeTag } = props

  return (
    <>
      {values.map((tagColor) => {
        const matchingOption = tagsOptions[decodeURIComponent(tagType)]?.find((option) => option.name === tagColor)
        const currentColor = clearColorHexa(matchingOption?.title || '')
        const isWhite = currentColor?.toLowerCase() === '#fff' || currentColor?.toLowerCase() === '#ffffff' ? '-is-white' : ''

        return matchingOption && (
          <div className="filtered-item" key={tagColor}>
            <div style={{
              background: matchingOption.pattern
                ? `url('${matchingOption.pattern}') no-repeat scroll center`
                : isMulticolor(matchingOption.title)
                  ? `linear-gradient(50deg, ${clearColorHexa(matchingOption.title)})`
                  : clearColorHexa(matchingOption.title)
            }} className={`filtered-color ${isWhite}`}></div>
            <button aria-label={`Limpar filtro de cor: ${translateString(clearColorTitle(matchingOption.title) || '')}`} className="filtered-items-button-clear" onClick={() => removeTag(tagColor, tagType)}></button>
          </div>
        )
      })}
    </>
  )
}

export default FilteredColorTag
